import { CreateEventComponent } from './events/create-event/create-event.component';
import { CreateEvent } from './events/store/event.actions';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { homeRoutes, HOME_DECLARATIONS } from './home.routing';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MAT_DECLARATIONS, MAT_PROVIDERS } from '../../shared/material.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import { ContentEditableFormDirective } from '../../directives/content-editable-form.directive';
import { ChangeOwnerDialogComponent } from './tasks/change-owner/change-owner.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { AllDocumentsComponent } from './resources/all-documents/all-documents.component';
import { DocumentComponent } from './resources/document/document.component';
import { AllDocumentsDialogComponent } from 'src/app/dialogs/all-documents-dialog/all-documents-dialog.component';
import { UploadDocumentDialog } from 'src/app/dialogs/upload-document/upload-document-dialog.component';
import { MyFoldersComponent } from './resources/my-folders/my-folders.component';
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { FileTypeValidator } from 'src/app/directives/image-validation';
import { DocumentListComponent } from './resources/doc-list-view/doc-list-view.component';
import { AddRoleComponent, EditRoleComponent } from '.';
import { ChangePhoneComponent } from './profile/change-phone/change-phone.component';
import { MergeTagsDialogComponent } from './tags/listing-tags/merge-tags-dialog/merge-tags-dialog.component';
import { ManageNotificationsComponent } from './notifications/manage-notifications/manage-notifications.component';
import { MemberGrpListComponent } from './private-members/member-grp-list/member-grp-list.component';
import { AddMemberGroupComponent } from './private-members/add-member-group/add-member-group.component';
import { PrivateMemberGroupDetailComponent } from './private-members/private-member-group-detail/private-member-group-detail.component';
import { UserBulkInviteComponent } from './user-management/user-bulk-invite/user-bulk-invite.component';
import { ModifyReplacementPatternComponent } from './templates/replacement-patterns/modify-replacement-pattern/modify-replacement-pattern.component';
import { AddReplacementPatternDialogComponent } from './templates/replacement-patterns/add-replacement-pattern-dialog/add-replacement-pattern-dialog.component';
import { ReplaceDocumentDialogComponent } from './resources/replace-document-dialog/replace-document-dialog.component';
import { ReplaceDocumentComponent } from './resources/replace-document/replace-document.component';
import { UserLogComponent } from './user-management/user-log/user-log.component';
import { ReplaceUserComponent } from './user-management/replace-user/replace-user.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DocumentPreviewDialogComponent } from './resources/document-preview-dialog/document-preview-dialog.component'
import { TagsActivityComponent } from './tags/listing-tags/tags-activity/tags-activity.component';
import { RenameFolderDialogueComponent } from './resources/rename-folder-dialogue/rename-folder-dialogue.component'
import { TestTemplateDialog } from './templates/test-template-dialog/test-template-dialog.component';
import { ListComponent } from './notifications/web-notifications/list/list.component';
import { ResetUserComponent } from './user-management/reset-user/reset-user.component';
import { DocSortSelectorComponent } from './resources/docs-sort-selector/docs-sort-selector.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ViewLogsComponent } from './capabilities/view-logs/view-logs.component';
import { DocActivityLogComponent } from './resources/doc-activity-log/doc-activity-log.component';

// import { EventFormSubmissionComponent } from './events/event-form-submission/event-form-submission.component';

registerPlugin(FilePondPluginFileValidateSize);

@NgModule({
  declarations: [
    ...HOME_DECLARATIONS,
    // EventFormSubmissionComponent,
    ContentEditableFormDirective,
    AllDocumentsDialogComponent,
    DocumentComponent,
    UploadDocumentDialog,
    MyFoldersComponent,
    MemberGrpListComponent,
    AddMemberGroupComponent,
    PrivateMemberGroupDetailComponent,
    FileTypeValidator,
    ChangePhoneComponent,
    DocumentListComponent,
    MergeTagsDialogComponent,
    UserBulkInviteComponent,
    ManageNotificationsComponent,
    ModifyReplacementPatternComponent,
    AddReplacementPatternDialogComponent,
    ReplaceDocumentDialogComponent,
    ReplaceDocumentComponent,
    UserLogComponent,
    ReplaceUserComponent,
    TagsActivityComponent,
    DocumentPreviewDialogComponent,
    RenameFolderDialogueComponent,
    TestTemplateDialog,
    ListComponent,
    ResetUserComponent,
    DocSortSelectorComponent,
    ViewLogsComponent,
    DocActivityLogComponent,


  ],
  imports: [
    StoreModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPermissionsModule,
    ...MAT_DECLARATIONS,
    RouterModule.forChild(homeRoutes),
    NgSelectModule,
    FilePondModule,
    SharedModule,
    CommonComponentsModule,
    NgxDocViewerModule,
    NgxPaginationModule
  ],
  entryComponents: [
    AddRoleComponent, EditRoleComponent, ChangeOwnerDialogComponent,
    AllDocumentsComponent, AllDocumentsDialogComponent, UploadDocumentDialog,
    RenameFolderDialogueComponent,
    ChangePhoneComponent, MergeTagsDialogComponent, AddReplacementPatternDialogComponent,
    ReplaceDocumentDialogComponent, ReplaceUserComponent, DocumentPreviewDialogComponent,
    TestTemplateDialog, ResetUserComponent
  ],
  providers: [...MAT_PROVIDERS],
  bootstrap: []
})
export class HomeModule { }
